import '../../style/colors.css'
import '../../style/basicStyle.css'
import './BasicPage.css'
import '../action/Tooltip.css'
import '../action/Toaster.css'
import { useEffect, type ReactNode } from 'react'
import { useIsOnline } from '@/hooks/useIsOnline'
import { useApi } from '@/hooks/useApi'
import { LogoText } from '../graphics/LogoText'
import { Tooltip } from '../action/Tooltip'
import { routes } from '@/utilities/routes'
import { Link } from 'react-router-dom'
import { Icon } from '../graphics/Icon'
import { Toaster } from '../action/Toaster'
import { cn } from '@/utilities/misc'
import { Button } from '../action/Button'
import { UserRole } from 'aevocam-rest-api-spec'

type Props = {
  title?: string
  className?: string
  toolbarButtons?: ReactNode
  children: ReactNode
}

export function BasicPage({
  title,
  className,
  toolbarButtons,
  children,
}: Props) {

  const isOnline = useIsOnline()
  const api = useApi()

  useEffect(() => {
    document.title = (title && title !== '') ? `${title} - Aevocam` : 'Aevocam'
  }, [title])

  //--------------------------------------------------------------------------------
  // Render
  return (
    <div className={cn('BasicPage', className)}>
      {api.status.needsRefresh && (
        <div className='NeedsRefresh'>
          <Icon icon='exclamationTriangle' />
          <span>New version available. Refresh your browser.</span>
        </div>
      )}
      {!isOnline && (
        <div className='Offline'>
          <Icon icon='exclamationTriangle' />
          <span>Your machine is offline.</span>
        </div>
      )}
      <header>
        <Link to={routes.home()} className='LogoLink'>
          <Tooltip>To the home page</Tooltip>
          <LogoText />
        </Link>
        {title && title !== '' && (
          <h1>
            <Tooltip>{title}</Tooltip>
            {title}
          </h1>
        )}
      </header>

      <div className='Toolbar'>

        <div className='Actions'>
          {toolbarButtons}
        </div>

        <div className='User'>
          {api.status.session?.userRole === UserRole.Admin && (<>
            <Button
              label='Admin'
              icon='shield'
              href={routes.admin()}
            />
          </>)}
          <Button
            label={ api.status.session?.userName ?? 'User' }
            icon='user'
            tooltip='My user account'
            className='User'
            href={routes.home()}
          />
        </div>

      </div>

      <div className='NavAndContent'>
        <main>
          {children}
        </main>
      </div>

      <Toaster />
      <div id='TooltipCorral' />

    </div>
  )
}
